<template>
  <el-dialog
    v-if="visible"
    show-close
    :visible.sync="visible"
    width="1000px"
    :title="title"
    :close-on-click-modal="false"
    :before-close="() => close()"
    destroy-on-close
    append-to-body
    v-el-dialog-drag
  >
    <ChooseBatch
      ref="chooseBatchInner"
      :height="height"
      :shipmentCode="shipmentCode"
      @confirm="chooseContainerBoxConfirm"
    />
    <span slot="footer"> </span>
  </el-dialog>
</template>
<script>
import ChooseBatch from './index.vue'
export default {
  components: { ChooseBatch },
  props: {
    visible: { type: Boolean, default: false },
    title: { type: String, default: '' },
    height: { type: Number, default: 600 },
    shipmentCode: { type: String, default: '' },
  },
  mounted() {},
  methods: {
    close() {
      this.$emit('update:visible', false)
      this.$emit('close')
    },
    chooseContainerBoxConfirm() {
      this.$emit('confirm')
    }
  }
}
</script>
